import React, { useState } from 'react';
import {VolumeOverloadIcon, ManualTasksIcon, KnowledgeLossIcon, EscalatingCostsIcon} from './Icon'
import '../css/SectionTwo.css'
import screenshot from '../assets/Crikey_ss.jpeg'


interface CardData {
  icon: React.ReactNode;
  title: string;
  description: string;
  stat: string;
  statDescription: React.ReactNode;
}

const SectionTwo: React.FC = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const [particles] = useState(() => 
    Array.from({ length: 50 }, () => ({
      top: Math.random() * 100,
      left: Math.random() * 100,
      delay: Math.random() * 5,
      duration: 15 + Math.random() * 10
    }))
  );

  const cardsData: CardData[] = [
    {
      icon: <VolumeOverloadIcon />,
      title: 'Volume overload',
      description: 'Claims processing is slow, leaving families in limbo after disasters.',
      stat: '60%',
      statDescription: 'We reduce claims processing time by 60%, so families get back on their feet faster'
    },
    {
      icon: <ManualTasksIcon />,
      title: 'Manual tasks',
      description: 'Agents are stretched thin, balancing high stakes with complex workloads.',
      stat: '70%',
      statDescription: <span>Crikey<sup>ai</sup> handles repetitive tasks, freeing agents to spend 70% more time on complex cases requiring their expertise and empathy.</span>
    },
    {
      icon: <EscalatingCostsIcon/>,
      title: 'Captured knowledge',
      description: 'Corporate knowledge embedded forever.',
      stat: '3x',
      statDescription: 'Faster onboarding for new employees.'
    },
    {
      icon: <KnowledgeLossIcon/>,
      title: 'Faster help',
      description: 'Without AI, critical claims can take weeks or months to resolve.',
      stat: '5x',
      statDescription: <span>With Crikey<sup>ai</sup>, claims resolve up to 5x faster, getting people the help they need when it matters most.</span>
    }
  ];

  return (
    <>
      <div className="section-two-container">

        <div className="content-wrapper">
          <div className="header-section">
            <h2 className="main-heading">
              Good for customers.<br />
              Great for teams. <span className="highlight-text">Best for business.</span>
            </h2>

            <h2 className="description-text">
              As claims grow more complex, Crikey<sup>ai</sup> gives every agent the best 
              insights and efficiencies - instantly and consistently.
            </h2>

            <h2 className="tagline">
              Unlocking the power of AI to enhance the human potential.
            </h2>
          </div>

          <div className="cards-grid">
            {cardsData.map((card, index) => (
              <div
                key={index}
                className="card"
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="card-default-content">
                  <div className="card-icon">{card.icon}</div>
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-description">{card.description}</p>
                </div>

                <div className="card-hover-content">
                  <div className="card-stat">{card.stat}</div>
                  <p className="card-stat-description">{card.statDescription}</p>
                </div>
              </div>
            ))}
          </div>
                <div className='divider-container'>
          <h2 className='divider-text'>The AI tool built for insurance</h2>
          <div className='divider-container-card-row'>
              <p className='divider-p-text'>Crikey<sup>ai</sup> automates repetitive tasks, analyses documents in real time, enables and scales your best people - instantly.</p>
              <img src={screenshot} className='divider-image' alt="Nimbli screenshot" />
          </div>
      </div>
        </div>
      </div>
    </>
  );
};

export default SectionTwo;